import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import * as playlistActions from "../../actions/playlist";
import {withRouter} from 'react-router';
import {Modal, ModalBody} from 'reactstrap';
import UploadFile from '../includes/UploadFile';
import {IMGIX_PATH} from "../../constants";
import * as uploadActions from "../../actions/upload";
import AuthService from "../../lib/AuthService";

class NewPlaylist extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            modal: false,
            wrapClass : 'Playlist-container ',
            items : undefined,
            image_path: null,
            playlistName: "",
            playlistDesc:"",
            playlistId:'',
            nameError : '',
            descError: ''
        };
        this.Auth = new AuthService();
        this.handleInputChange = this.handleInputChange.bind(this);
        this.mToggle = this.mToggle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    getUploadedFile(fileName) {
        console.log(fileName);
        this.setState({
            image_path: fileName
        });

        //Request to purging
        this.props.getImagepurged({image_name : this.state.playlistId, image_path : fileName});

    }
    shouldComponentUpdate(nextProps, nextState){

        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        // Typical usage (don't forget to compare props):

        if(this.props.playlistData.showPlaylistForm !== prevProps.playlistData.showPlaylistForm) {
            this.mToggle();
        }

        if(this.props.playlistData.playListDetail && this.props.playlistData.playListDetail !== prevProps.playlistData.playListDetail) {

            this.setState({'image_path' : IMGIX_PATH+'assets/slider/'+this.props.playlistData.playListDetail.pl_id+'.jpg?t='+Math.random()+'&fit=crop&h=150&w=150&auto=enhance&dpr=3%203x',
                'playlistName' : this.props.playlistData.playListDetail.pl_name,
                'playlistDesc' : this.props.playlistData.playListDetail.pl_desc,
                'playlistId' : this.props.playlistData.playListDetail.pl_id })

        }

        if(this.props.playlistData.newImage !== prevProps.playlistData.newImage ) {
            this.setState({image_path : this.props.playlistData.newImage});
        }
    }


    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });

        if(event.target.value !== '') {
            event.target.classList.remove('is-invalid');
        }
        if(this.state.playlistName !== ''){
            this.setState({
                nameError: ''
            });
        }
        if(this.state.playlistDesc !== ''){
            this.setState({
                descError: ''
            });
        }
    }
    handleSubmit(e) {
        console.log(this.state);
        //e.preventDefault();
        let formInvalid = 0;

        //Name validation

        if( this.state.playlistName === '') {
            formInvalid++;
            document.getElementsByName('playlistName')[0].classList.add('is-invalid');
            this.setState({
                nameError: 'Name is required'
            });
        };

        //* Desc validation
        if( this.state.playlistDesc === '') {
            formInvalid++;
            document.getElementsByName('playlistDesc')[0].classList.add('is-invalid');
            this.setState({
                descError: 'Description is required'
            });
        };



        if( formInvalid === 0) {

            let plId = (this.props.playlistData && this.props.playlistData.playListDetail && this.props.playlistData.playListDetail.pl_id) ? this.props.playlistData.playListDetail.pl_id : '';
            var playlistData = { plName: this.state.playlistName, plDesc : this.state.playlistDesc, user_id : this.Auth.getProfile().user_id , vigIds:'', plImage : this.state.image_path, plId : plId};
            console.log(playlistData);
            let playlistCreated = this.props.createPlaylist(playlistData);
            console.log(playlistCreated);
            //this.props.forceUpdateHandler();
            this.mToggle();


        }

    }

    mToggle() {
        console.log(this.state.showPop);
        this.setState({
            showPop: !this.state.showPop
        });
        this.props.uploadErrors({'error' : '', fileType : ''});
        if(this.props.playlistData.newPlaylist) {
            this.resetState();
        }

    }
    resetState(){
        this.setState({
            playlistName: '',
            playlistDesc:'',
            image_path: null,
            nameError : '',
            descError: ''
        });
        this.props.uploadErrors({'error' : '', fileType : ''});
    }



    render() {

        return (
            <Modal isOpen={this.state.showPop} toggle={this.mToggle} centered={true} className="vig-mod modal-lg vig-modal user-md create-new-pop" id="vignetModal-user" tabindex="-1" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <ModalBody>
                    <div className="modal-header">
                        <form id="company">
                            <button type="button" className="modal-btn-close" data-dismiss="modal"
                                    aria-label="Close" onClick={this.mToggle}>✕
                            </button>
                            <h4 className="modal-title ">{this.props.playlistData.newPlaylist? "Create Playlist" : "Edit Playlist" }</h4>
                        </form>
                    </div>

                    <div className="modal-adduser-content">

                        <div className="modal-adduser-detail-name">
                            <p>NAME</p>
                            <div className="input-select">
                                <input type="user-name" name="playlistName" placeholder="New Playlist"
                                       defaultValue={this.state.playlistName} onChange={this.handleInputChange}/>
                                <p className="error-message">{this.state.nameError}</p>
                            </div>
                        </div>
                        <div className="modal-description-detail">
                            <p>DESCRIPTION</p>
                            <div className="input-select desc-area">
                                    <textarea name="textarea" name="playlistDesc"
                                              placeholder="Give your playlist a catchy description"
                                              onChange={this.handleInputChange} defaultValue={this.state.playlistDesc}></textarea>
                                    <p className="error-message">{this.state.descError}</p>
                            </div>
                        </div>

                        <div className="modal-adduser-content-right">
                            <div className="modal-adduser-detail">
                                <p>IMAGE</p>
                                <div className="modal-adduser-img">
                                    <div className="image-up">

                                        {this.state.image_path &&
                                        <img src={this.state.image_path} crossOrigin="anonymous"
                                             className="text-center" alt="playlist"/>
                                        }
                                        {this.state.image_path === null &&
                                        <img src="assets/images/placeholder.png" alt="default"/>
                                        }

                                        <UploadFile getUploadedFile={this.getUploadedFile.bind(this)} type="add" progress="progress-bar-wrapper"
                                                    item_type="PLAYLIST" unique_id = {(this.props.playlistData && this.props.playlistData.playListDetail && this.props.playlistData.playListDetail.pl_id) ? this.props.playlistData.playListDetail.pl_id : ''} />


                                        {(this.state.image_path === null || this.props.uploadData.loader === true) &&

                                        <div id="progress-bar-wrapper"></div>
                                        }

                                    </div>
                                </div>
                                {this.props.uploadData.errors === true &&
                                <p className="error-message">{this.props.uploadData.errorMessage}</p>
                                }
                            </div>
                        </div>
                        <div className="modal-adduser-content-btn">
                            <div className="modal-btn btn-cancel">
                                <a href="javascript:void(0);" className="" onClick={this.mToggle}>CANCEL</a>
                            </div>
                            <div className="modal-btn btn-create">
                                <a href="javascript:void(0);" onClick={(e) => this.handleSubmit(e)}
                                   className="">{this.props.playlistData.newPlaylist? "CREATE" : "UPDATE" }</a>
                            </div>
                        </div>
                    </div>

                </ModalBody>
            </Modal>
        );
    }
}

NewPlaylist.propTypes = {
    showPlaylist: PropTypes.bool,
    showVignets : PropTypes.bool
}

function mapStateToProps(state) {
    return {
        playlistData  :state.playlist.playlistData,
        uploadData : state.upload.uploadData

    };

}
export default  withRouter(connect(mapStateToProps, {
    createPlaylist : playlistActions.createPlaylist,
    getImagepurged : playlistActions.purgeImage,
    uploadErrors: uploadActions.uploadErrors,
})(NewPlaylist));




// WEBPACK FOOTER //
// ./src/components/playlist/NewPlaylist.js